import { useAppConfigs } from '@config/config.hooks';
import { envConfigs } from '@config/envConfigs';
import { AzureLoginLogoutButton, Button, ComponentType, ILoggedInUser } from '@gcl/react-core';
import * as React from 'react';
import { identifyUser } from './dynatrace.services';

export interface IAccountLockedProps {}

export const AccountLocked: React.FC<IAccountLockedProps> = ({}) => {
  const appConfigs = useAppConfigs();

  return (
    <div className="gcl-p-sm">
      <div className="gcl-pb-sm">Your account is locked, please contact admin for assistance.</div>
      <AzureLoginLogoutButton
        scopes={[envConfigs.apiScope as string]}
        onUserLoggedIn={(user: ILoggedInUser) => {
          appConfigs.updateConfigs?.((configs) => {
            return { ...configs, loggedInUser: user };
          });
          identifyUser(user.username || '');
        }}
        validateIssuers={(issuer) => {
          if (!envConfigs?.validIssuers) return true;
          return envConfigs.validIssuers.split(',').some((validIssuer) => {
            // issuer format 'https://login.microsoftonline.com/{tenantId}/v2.0
            return issuer.includes(validIssuer);
          });
        }}
        render={(isLoggedIn, onClickLoginLogoutBtn, accounInfo, imageSrc) => {
          return isLoggedIn ? (
            <Button
              style={{ margin: '0 auto 10px auto' }}
              className="gcl-clickable"
              onClick={onClickLoginLogoutBtn}
              type={ComponentType.Primary}
              prefixIconName="Microsoft"
            >
              <span>Sign Out</span>
            </Button>
          ) : null;
        }}
      />
    </div>
  );
};
